export default "__VITE_ASSET__BpU67lTz__"